import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button, Card, Form, Carousel } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { ArrowRight, Award, Truck, HeadphonesIcon, Shield, Star, ShoppingCart } from 'lucide-react';
import ProductCard from '../components/ProductCard';
import StoreMap from '../components/StoreMap';
import { heroImages, featuredProducts, testimonials, allProducts } from '../data/mockData';
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import { useNavigate } from "react-router-dom";

const Home = () => {
  const [email, setEmail] = useState('');
  const [products, setProducts] = useState([]);
  const [categoriesData, setCategoriesData] = useState([]);
  const [animalsData, setAnimalsData] = useState([]);
  const [foodData, setFoodData] = useState([]);
  const [featuredData, setFeaturedData] = useState([]);
  const [brandsData, setBrandsData] = useState([]);
  const [breedsData, setBreedsData] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    fetchBrandsData();
    fetchBreedsData();
    fetchProducts();
    fetchCategoriesData();
    fetchAnimalData();
    fetchFoodData();
    fetchFeaturedData();
  }, []);

      const fetchBreedsData = async () => {
        const querySnapshot = await getDocs(collection(db, "breeds"));

        const list = querySnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
        }));

        setBreedsData(list)
    };

      const fetchBrandsData = async () => {
        const querySnapshot = await getDocs(collection(db, "brands"));

        const list = querySnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
        }));

        setBrandsData(list)
    };

  const fetchFeaturedData = async () => {
    const querySnapshot = await getDocs(collection(db, "featuresServices"));

    const list = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    setFeaturedData(list)
  };

  const fetchAnimalData = async () => {
    const querySnapshot = await getDocs(collection(db, "animalCategories"));

    const list = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    setAnimalsData(list)
  };

  const fetchFoodData = async () => {
    const querySnapshot = await getDocs(collection(db, "foodCategories"));

    const list = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    setFoodData(list)
  };



  const fetchProducts = async () => {
    const querySnapshot = await getDocs(collection(db, "products"));

    const list = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    setProducts(list)
  };

  const fetchCategoriesData = async () => {
    const querySnapshot = await getDocs(collection(db, "categories"));

    const list = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    setCategoriesData(list)
  };

  const goToProductPage = (type, id) => {
     navigate(`/products?${type}=${id}`);
   };

     const goToAnimalsPage = (type, id) => {
     navigate(`/animals?${type}=${id}`);
   };
   

  const carouselSlides = [
    {
      id: 1,
      title: 'QUALITY PET CARE',
      subtitle: 'Premium Products',
      description: 'Welcome to FocoPet, your ultimate online pet store! We\'re more than just an online pet food shop - we\'re your partners in pet parenting.',
      image: "https://firebasestorage.googleapis.com/v0/b/todo-studio-159af.appspot.com/o/topBanners%2Fdog1.png?alt=media&token=ca6b5199-0f56-4658-8453-a6048976d82b"
    },
    {
      id: 2,
      title: 'HAPPY PETS',
      subtitle: 'Happy Life',
      description: 'Discover a wide range of premium pet products designed to keep your furry friends healthy and happy every day.',
      image: "https://firebasestorage.googleapis.com/v0/b/todo-studio-159af.appspot.com/o/topBanners%2Fcat1.png?alt=media&token=cc8be358-6e1c-4f45-a365-a1b4c2a02bd2"
    },
    {
      id: 3,
      title: 'BE YOUR OWN',
      subtitle: 'Pet Guardian',
      description: 'From nutritious food to fun toys, we have everything your pet needs to thrive and live their best life.',
      image: "https://firebasestorage.googleapis.com/v0/b/todo-studio-159af.appspot.com/o/topBanners%2Fdog2.png?alt=media&token=bb9a5ff7-ed80-47ca-b2a0-86a4d05bd244"
    },
    {
      id: 4,
      title: 'THE LOOKBOOK',
      subtitle: 'Season 2025',
      description: 'Shop with confidence knowing every product is carefully selected for quality and safety for your beloved pets.',
      image: "https://firebasestorage.googleapis.com/v0/b/todo-studio-159af.appspot.com/o/topBanners%2Fdog1.png?alt=media&token=ca6b5199-0f56-4658-8453-a6048976d82b"
    }
  ];

  return (
    <div>
      {/* Editorial Style Hero Carousel */}
      <section className="editorial-carousel-section px-4 my-4">
        <Carousel
          interval={3000}
          controls={true}
          indicators={false}
          pause={false}
          fade={true}
        >
          {carouselSlides.map((slide, index) => (
            <Carousel.Item key={slide.id}>
              <div className="editorial-slide">
                {/* Background Image */}
                <div
                  className="editorial-bg"
                  style={{
                    backgroundImage: `url(${slide.image})`
                  }}
                />

                {/* Gradient Overlay */}
                <div className="editorial-overlay" />

                {/* Content Container */}
                <Container className="editorial-content">
                  <Row className="h-100 align-items-center justify-content-center">
                    <Col lg={8} xl={7} className="editorial-text text-center">
                      <h1 className="editorial-title">
                        {slide.title}
                      </h1>
                      <h2 className="editorial-subtitle">
                        {slide.subtitle}
                      </h2>
                      <p className="editorial-description mx-auto">
                        {slide.description}
                      </p>
                      <Button
                        as={Link}
                        to="/products"
                        className="editorial-btn"
                      >
                        EXPLORE MORE
                      </Button>
                    </Col>
                  </Row>
                </Container>

                {/* Social Links */}
                <div className="carousel-social">
                  <a href="#" className="social-link">FB</a>
                  <a href="#" className="social-link">TW</a>
                  <a href="#" className="social-link">IG</a>
                </div>

                {/* Decorative Elements */}
                <div className="decorative-circle decorative-circle-1" />
                <div className="decorative-circle decorative-circle-2" />
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
      </section>

      {/* Quality Pet Food Section */}
      <section className="quality-pet-section">
        <Row className="g-0">
          {/* Left Side - Pets with Blue Background and Pink Bottom */}
          <Col lg={6} className="pets-showcase-wrapper">
            {/* Blue section with pets */}
            <div className="pets-showcase">
              <div className="pets-single-image">
                <img
                  src="https://customer-assets.emergentagent.com/job_modern-bs5-site/artifacts/1kuvitaf_ChatGPT%20Image%20Nov%2010%2C%202025%2C%2011_00_24%20PM.png"
                  alt="Happy Pets - Cat, Parrot, Dog, and Bird"
                  className="pets-group-img"
                />
              </div>
            </div>

            {/* Pink Section - Product Cards at bottom of blue section */}
            <div className="products-strip">
              <h4 className='w-100 text-center mb-3'>
                What we offer that others <span className="highlight-text">don't</span>
              </h4>


              <Row className="justify-content-center g-3">

                <Carousel interval={1000} controls={true}
                  indicators={false}>

                  {featuredData.map((item) => (
                    <Carousel.Item className='featuredSliderItem'>

                      <div className='featuredSlider'>
                        <img src={item?.image}
                          alt="First slide"
                        />

                        {/* <Carousel.Caption className='featuredSliderCaption'>
                           <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                        </Carousel.Caption> */}
                      </div>
                    </Carousel.Item>
                  ))}

                </Carousel>


              </Row>
            </div>
          </Col>

          {/* Right Side - Text with Yellow Background */}
          <Col lg={6} className="quality-text-section">
            <div className="quality-content">
              <h2 className="quality-heading">
                Quality pet <br />
                food <span className="highlight-text">ensures</span><br />
                pet well-being
              </h2>
              <p className="quality-description">
                Welcome to FURRMAA, your ultimate online pet store! We're more than just an online pet food shop - we're your partners in pet parenting.
              </p>
              <Button
                as={Link}
                to="/products"
                className="quality-btn"
              >
                Get Started <ArrowRight className="ms-2" size={20} />
              </Button>
            </div>
          </Col>
        </Row>
      </section>

      {/* Pet Product Category Section */}
      <section className="py-5 bg-light">
        <Container>
          <div className="d-flex justify-content-center align-items-center mb-4">
            <div>
              <h2 className="fw-bold mb-2 w-100 text-center">Shop By Animals</h2>
              <p className="text-muted w-100 text-center">Welcome To FURRMAA, Your Ultimate Online Pet Store! At FURRMAA, We're More Than Just A Pet Shop Online - We're Your Partners In Pet Parenting.</p>
            </div>
          </div>

          <Row className="g-4 d-flex justify-content-center">
            {animalsData.map((category) => (
              <Col key={category.id} md={3} onClick={() => goToAnimalsPage(category.name,category.id)}>
                <Card className="border-0 shadow-sm h-100">
                  <div className="position-relative overflow-hidden" style={{ height: '300px' }}>
                    <img
                      src={category.image}
                      alt={category.name}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        transition: 'transform 0.3s ease'
                      }}
                    />
                    <div
                      className="position-absolute bottom-0 start-0 w-100 p-3"
                      style={{
                        background: 'linear-gradient(to top, rgba(0,0,0,0.8), transparent)'
                      }}
                    >
                      <h4 className="text-white fw-bold mb-1">{category.name}</h4>
                    </div>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Products Section */}
      <section className="py-5">
        <Container>
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              <h2 className="fw-bold mb-2">Shop By Brands</h2>
              <p className="text-muted">Browse our wide selection of premium pet product brands</p>
            </div>
          </div>

          <div className="g-4 horizontalScroll pb-3">

            {brandsData.map((category) => (
              <div className="scroll-item p-0 mx-2" key={category?.id}>
                <Card className="border-0 shadow-sm category-card h-100" onClick={() => goToProductPage('animal', category?.id)}>
                  <div className="position-relative overflow-hidden" >
                    <img
                      src={category.image}
                      alt={category.name}
                      style={{
                        width: '170px',
                        height: '170px',
                        objectFit: 'cover',
                        transition: 'transform 0.3s ease'
                      }}
                      className="category-image"
                    />
                    <div
                      className="categoryNameText w-100 p-3"
                      style={{
                        background: 'linear-gradient(to top, rgb(0 0 0 / 99%), #0000000f)'
                      }}
                    >
                      <h4 className="text-white fw-bold mb-1 textInitial">{category.name}</h4>
                    </div>
                  </div>
                </Card>
              </div>
            ))}
          </div>

        </Container>
      </section>

      {/* Products Section */}
      <section className="py-5">
        <Container>
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              <h2 className="fw-bold mb-2">Shop By Category</h2>
            </div>
            <Button
              as={Link}
              to="/products"
              style={{
                backgroundColor: '#a5cb89',
                border: 'none',
                borderRadius: '25px',
                padding: '10px 30px'
              }}
              className="d-none d-md-inline-flex align-items-center linkButton"
            >
              Explore More <ArrowRight className="ms-2" size={18} />
            </Button>
          </div>

          <Row className="g-4">
            {categoriesData.map((category) => (
              <Col key={category.id} sm={6} md={3} lg={2}>

                <Card className="h-100 shadow-md border-0 product-card">
                  <div className="position-relative overflow-hidden" style={{ height: '150px' }}>
                    <Card.Img
                      variant="top"
                      src={category.image}
                      alt={category.name}
                      style={{
                        height: '100%',
                        objectFit: 'cover',
                        transition: 'transform 0.3s ease'
                      }}
                      className="product-image"
                    />
                  </div>
                  <Card.Body className="d-flex flex-column py-0">
                    <Card.Title className="fs-6 my-1 categoryCustomCardText text-center">{category.name}</Card.Title>
                  </Card.Body>
                </Card>
              </Col>

            ))}
            {/* {products.slice(0, 6).map((product) => (
              <Col key={product.id} sm={6} md={3} lg={2}>
                <ProductCard product={product} />
              </Col>
            ))} */}
          </Row>

          {/* Mobile Explore More Button */}
          <div className="d-md-none text-center mt-4">
            <Button
              as={Link}
              to="/products"
              style={{
                backgroundColor: '#a5cb89',
                border: 'none',
                borderRadius: '25px',
                padding: '10px 30px'
              }}
              className="d-inline-flex align-items-center"
            >
              Explore More <ArrowRight className="ms-2" size={18} />
            </Button>
          </div>
        </Container>
      </section>

      <section className="py-5 bg-light">
        <Container>
          <div className="d-flex justify-content-center align-items-center mb-4">
            <div>
              <h2 className="fw-bold mb-2 w-100 text-center">Shop By Breed</h2>
            </div>
          </div>

          <div className="g-4 horizontalScroll breedsMainDiv py-3">
            {breedsData.map((category) => (
               <div className="scroll-item p-0 mx-0" key={category?.id}>
              <Card className="border-0 shadow-sm h-100 shopByBreedCard p-0 mx-2">
                <div className="position-relative overflow-hidden" style={{ height: '300px' }}>
                  <img
                    src={category.image}
                    alt={category.name}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      transition: 'transform 0.3s ease',
                      borderRadius: '15px'
                    }}
                  />
                  <div
                    className="position-absolute bottom-0 start-0 w-100 p-3 shopByBreedCardBottom"
                    style={{
                      background: 'linear-gradient(to top, rgba(0,0,0,0.8), transparent)',
                    }}
                  >
                    <h4 className="text-white fw-bold mb-1 text-center textInitial">{category.name}</h4>
                  </div>
                </div>
              </Card>
              </div>
            ))}
          </div>

        </Container>
      </section>

      {/* Products Section */}
      <section className="py-5">
        <Container>
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              <h2 className="fw-bold mb-2">Our top selling products</h2>
            </div>
            <Button
              as={Link}
              to="/products"
              style={{
                backgroundColor: '#a5cb89',
                border: 'none',
                borderRadius: '25px',
                padding: '10px 30px'
              }}
              className="d-none d-md-inline-flex align-items-center linkButton"
            >
              Explore More <ArrowRight className="ms-2" size={18} />
            </Button>
          </div>

          <Row className="g-4">
            {products.slice(0, 6).map((product) => (
              <Col key={product.id} sm={6} md={3} lg={2}>
                <ProductCard product={product} />
              </Col>
            ))}
          </Row>

          {/* Mobile Explore More Button */}
          <div className="d-md-none text-center mt-4">
            <Button
              as={Link}
              to="/products"
              style={{
                backgroundColor: '#a5cb89',
                border: 'none',
                borderRadius: '25px',
                padding: '10px 30px'
              }}
              className="d-inline-flex align-items-center"
            >
              Explore More <ArrowRight className="ms-2" size={18} />
            </Button>
          </div>
        </Container>
      </section>

      {/* Store Location Map Section */}
      <section className="py-5 bg-light">
        <Container>
          <div className="text-center mb-4">
            <h2 className="fw-bold mb-3">Visit Our Allies</h2>
            <p className="text-muted">Find pet stores near you</p>
          </div>

          <div style={{ height: '500px', borderRadius: '12px', overflow: 'hidden' }} className="shadow">
            <StoreMap />
          </div>
        </Container>
      </section>

      {/* Why Choose Us Section */}
      <section className="py-5">
        <Container>
          <div className="text-center mb-5">
            <h2 className="fw-bold mb-3">Why Choose FURRMAA?</h2>
            <p className="text-muted">We're committed to providing the best for your pets</p>
          </div>
          <Row className="g-4">
            <Col md={4} sm={6}>
              <Card className="text-center border-0 shadow-sm h-100 p-3">
                <div className="d-flex justify-content-center mb-3">
                  <div
                    className="rounded-circle d-flex align-items-center justify-content-center"
                    style={{
                      width: '80px',
                      height: '80px',
                      backgroundColor: '#E3F2FD'
                    }}
                  >
                    <Award size={40} style={{ color: '#4A90E2' }} />
                  </div>
                </div>
                <h5 className="fw-bold mb-2">Premium Quality</h5>
                <p className="text-muted small">Only the best products for your beloved pets</p>
              </Card>
            </Col>
            <Col md={4} sm={6}>
              <Card className="text-center border-0 shadow-sm h-100 p-3">
                <div className="d-flex justify-content-center mb-3">
                  <div
                    className="rounded-circle d-flex align-items-center justify-content-center"
                    style={{
                      width: '80px',
                      height: '80px',
                      backgroundColor: '#FFF3E0'
                    }}
                  >
                    <Truck size={40} style={{ color: '#a5cb89' }} />
                  </div>
                </div>
                <h5 className="fw-bold mb-2">Fast Delivery</h5>
                <p className="text-muted small">Quick and reliable shipping to your doorstep</p>
              </Card>
            </Col>

            <Col md={4} sm={6}>
              <Card className="text-center border-0 shadow-sm h-100 p-3">
                <div className="d-flex justify-content-center mb-3">
                  <div
                    className="rounded-circle d-flex align-items-center justify-content-center"
                    style={{
                      width: '80px',
                      height: '80px',
                      backgroundColor: '#E8F5E9'
                    }}
                  >
                    <Shield size={40} style={{ color: '#4CAF50' }} />
                  </div>
                </div>
                <h5 className="fw-bold mb-2">Safe & Secure</h5>
                <p className="text-muted small">Your pet's safety is our priority</p>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Testimonials Section */}
      <section className="py-5">
        <Container>
          <div className="text-center mb-5">
            <h2 className="fw-bold mb-3">What Our Customers Say</h2>
            <p className="text-muted">Don't just take our word for it</p>
          </div>
          <Row className="g-4">
            {testimonials.map((testimonial) => (
              <Col key={testimonial.id} md={4}>
                <Card className="border-0 shadow-sm h-100">
                  <Card.Body className="p-4">
                    <div className="d-flex mb-3">
                      {[...Array(testimonial.rating)].map((_, i) => (
                        <Star key={i} size={18} fill="#FFD700" stroke="#FFD700" />
                      ))}
                    </div>
                    <p className="mb-4 text-muted">{testimonial.comment}</p>
                    <div className="d-flex align-items-center">
                      <img
                        src={testimonial.avatar}
                        alt={testimonial.name}
                        className="rounded-circle me-3"
                        style={{ width: '50px', height: '50px', objectFit: 'cover' }}
                      />
                      <div>
                        <h6 className="mb-0 fw-bold">{testimonial.name}</h6>
                        <small className="text-muted">Verified Customer</small>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

    </div>
  );
};

export default Home;